<template>
  <div class="select-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout.layout_type)">
      <label class="label"
             v-if="field.label"
             :class="getLabelClass(field.layout.layout_type)"
             :for="field.id">
        <span>
          {{ field.label }}
        </span>
      </label>
      <div class="control" :class="getControlClass(field.layout.layout_type)">
        <span class="select"
              :class="getInputClass(validation.is_valid)"
              v-if="!field.properties.input_readonly">
          <select v-model="formData.fields[field.id].value"
                  @change="formData.inputOnChange(field); removeValidation()"
                  :id="field.id"
                  :multiple="field.properties.multiple_options"
                  :name="field.id">
            <option v-for="(option, key) in field.properties.options"
                    :value="option.option_value"
                    :key="key">
              {{ option.display_name ? option.display_name : option.option_value }}
            </option>
          </select>
        </span>

        <input class="input" type="text" v-else
               :id="field.id"
               :name="field.id"
               :readonly="true"
               :value="getInputReadonlyValue(formData.fields[field.id].value)">

        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'select-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      removeValidation () {
        this.validation.is_valid = true
      },
      getFieldClass: function (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass: function (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass: function (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      },
      getInputReadonlyValue: function (value) {
        let option = this.field.properties.options.find(option => option.option_value === value)
        return option ? option.display_name : null
      },
      getInputClass: function (isValid) {
        return {
          'is-danger': !isValid
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  label > li
    list-style-position: inside

  span
    width: 100%

  select
    width: 100%

</style>
